(function ($) {

    $(document).ready(function(){
        $('#hamburger').click(function(e){
            e.preventDefault();
            $(this).toggleClass('open');
        });
        $('.offcanvas-backdrop').click( function(e) {
            e.preventDefault();
            $('#hamburger').toggleClass('open');
        })
    });

})( jQuery );